import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Organizar tus finanzas.', 'Detectar fugas de dinero.', 'Tomar mejores decisiones.', 'Planificar el crecimiento de tu negocio.', 'Aumentar tus ganancias.', 'Reducir el estrés financiero.'];
export function WhatIsIt() {
  return <section className="py-20 bg-white" data-id="element-402">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-403">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-404">
          <motion.div className="flex-1" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-405">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-406">
              ¿QUÉ ES REINICIA TUS FINANZAS?
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-407">
              <strong data-id="element-408">Reinicia Tus Finanzas</strong> es un sistema práctico y
              fácil de implementar diseñado para emprendedores, comerciantes y
              dueños de negocios que quieren recuperar el control de su dinero.
            </p>

            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-409">
              Aprenderás a:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 mb-8" data-id="element-410">
              {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3" data-id="element-411">
                  <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0" data-id="element-412" />
                  <span className="text-slate-700 font-medium" data-id="element-413">{benefit}</span>
                </div>)}
            </div>

            <div className="bg-success/10 border-l-4 border-success p-4 rounded-r-lg" data-id="element-414">
              <p className="text-navy-900 font-semibold" data-id="element-415">
                Todo explicado paso a paso, incluso si nunca estudiaste
                finanzas.
              </p>
            </div>
          </motion.div>

          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-416">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-square md:aspect-auto md:h-[500px] bg-navy-50 flex items-center justify-center p-8" data-id="element-417">
              {/* Abstract illustration of organization */}
              <div className="w-full h-full relative" data-id="element-418">
                <div className="absolute top-10 left-10 w-32 h-32 bg-navy-200 rounded-xl opacity-50 animate-pulse" data-id="element-419"></div>
                <div className="absolute bottom-20 right-10 w-40 h-40 bg-success/20 rounded-full opacity-50" data-id="element-420"></div>

                <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 z-10" data-id="element-421">
                  <div className="bg-white p-4 rounded-xl shadow-lg w-3/4 flex items-center gap-4 transform -rotate-2" data-id="element-422">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-500 font-bold" data-id="element-423">
                      -$
                    </div>
                    <div className="flex-1 h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-424">
                      <div className="w-3/4 h-full bg-red-400" data-id="element-425"></div>
                    </div>
                  </div>

                  <div className="w-8 h-8 flex items-center justify-center text-slate-300" data-id="element-426">
                    ↓
                  </div>

                  <div className="bg-white p-4 rounded-xl shadow-lg w-3/4 flex items-center gap-4 transform rotate-2 border-2 border-success" data-id="element-427">
                    <div className="w-10 h-10 bg-success-light rounded-full flex items-center justify-center text-success font-bold" data-id="element-428">
                      +$
                    </div>
                    <div className="flex-1 h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-429">
                      <div className="w-full h-full bg-success" data-id="element-430"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}